// extracted by mini-css-extract-plugin
export default {"link":"GtS8W","myMessage":"jlC5Q"};